import React, { useCallback, useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PriceSection } from './components/PriceSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { runWhenIdle, warmConnections } from './utils/preload';
import { MOCKUP_IMAGE, PRICE } from './data/content';
const CHECKOUT_URL = 'https://libres-de-ser.impultienda.ar/checkout';
export function App() {
  useEffect(() => {
    // Primero el render: se calientan las conexiones críticas y el pixel
    // se carga recién cuando el navegador está libre.
    warmConnections(CHECKOUT_URL, MOCKUP_IMAGE);
    runWhenIdle(initMetaPixel);
  }, []);
  const handleCheckout = useCallback(() => {
    // La navegación se dispara ya mismo; el evento del pixel no la bloquea.
    window.location.href = CHECKOUT_URL;
    trackPixelEvent('AddToCart', {
      content_name: 'Libres de Ser',
      content_type: 'product',
      value: Number(PRICE.current.replace('$', '')),
      currency: PRICE.currency
    });
  }, []);
  return <div className="min-h-full w-full bg-white font-sans text-ink" data-id="element-0" data-mp="4wxfu7a14id">
      <Hero data-id="element-1" data-mp="2zld2xbxu5jcl" />
      <main data-id="element-2" data-mp="2zllijblcf2rh">
        <PainSection data-id="element-3" data-mp="2zm4wkh7vh708" />
        <BenefitsSection data-id="element-4" data-mp="2zmo7vf30ox5a" />
        <PriceSection onBuy={handleCheckout} data-id="element-5" data-mp="2zng2amkvootz" />
        <TestimonialsSection data-id="element-6" data-mp="33nq4rp9gox43" />
        <FaqSection data-id="element-7" data-mp="33myl9ct52pu6" />
      </main>
      <Footer data-id="element-8" data-mp="38m1fs3bhtdnw" />
    </div>;
}